'use client';

import { createClient } from '@/lib/supabase/client';

function isSchemaError(error: any): boolean {
  if (!error) return false;

  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42') return true;
    if (errorClass === '23') return false;
    if (errorClass === '08') return true;
  }

  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
      /syntax error/i,
      /invalid.*syntax/i,
      /type.*does not exist/i,
      /undefined.*column/i,
      /undefined.*table/i,
      /undefined.*function/i,
    ];

    return schemaErrorPatterns.some((pattern) => pattern.test(error.message));
  }

  return false;
}

export const registrationService = {
  async subscribeNewsletter(email: string) {
    const supabase = createClient();

    try {
      const { data, error } = await supabase
        .from('newsletter_signups')
        .insert({
          email: email,
          subscribed_at: new Date().toISOString(),
          is_active: true,
        })
        .select()
        .single();

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Newsletter signup error:', error.message);
          return { success: false, error: error.message };
        }
      }

      return { success: true, data };
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },

  async submitStory(storyData: {
    displayName: string;
    location: string;
    storyTitle: string;
    transformation: string;
    quote: string;
    email: string;
    useRealName: boolean;
    sharePublicly: boolean;
    photoUrl?: string;
  }) {
    const supabase = createClient();

    try {
      const { data, error } = await supabase
        .from('story_submissions')
        .insert({
          display_name: storyData.displayName,
          location: storyData.location,
          story_title: storyData.storyTitle,
          transformation: storyData.transformation,
          quote: storyData.quote,
          email: storyData.email,
          use_real_name: storyData.useRealName,
          share_publicly: storyData.sharePublicly,
          photo_url: storyData.photoUrl || null,
          status: 'pending',
          submitted_at: new Date().toISOString(),
        })
        .select()
        .single();

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Story submission error:', error.message);
          return { success: false, error: error.message };
        }
      }

      return { success: true, data };
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};